module.exports = __webpack_public_path__ + "img/nasa-08-orange.d22bc651.svg";